import { useState, useEffect } from 'react';
import { useLang } from '@/pages/home/context/LanguageContext';

const navItemsPT = [
  { label: 'Início', href: '#home' },
  { label: 'Serviços', href: '#services' },
  { label: 'Setores', href: '#industries' },
  { label: 'Sobre Nós', href: '#about' },
  { label: 'Qualidade', href: '#quality' },
];

const navItemsEN = [
  { label: 'Home', href: '#home' },
  { label: 'Services', href: '#services' },
  { label: 'Sectors', href: '#industries' },
  { label: 'About Us', href: '#about' },
  { label: 'Quality', href: '#quality' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { lang, setLang } = useLang();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const navItems = lang === 'PT' ? navItemsPT : navItemsEN;
  const ctaLabel = lang === 'PT' ? 'Solicitar Orçamento' : 'Request a Quote';

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0B1A35] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
        {/* Logo */}
        <a href="#home" onClick={() => handleNav('#home')} className="flex items-center cursor-pointer">
          <div className="flex items-center px-3 py-1.5 rounded-xl bg-white">
            <img
              src="https://storage.readdy-site.link/project_files/9b9de9e7-eb12-4292-b652-c28199d74bb3/9fd39534-27e5-4545-8911-74a175747d13_d2adaf2b-9aa5-49c5-bdf3-902a8edfe9b3.png"
              alt="PAMIR"
              className="h-12 w-auto object-contain"
            />
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => handleNav(item.href)}
              className="text-white/90 hover:text-[#F97316] text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </nav>

        {/* Right side: Language switcher + CTA */}
        <div className="hidden md:flex items-center gap-3">
          {/* Language Switcher */}
          <div className="flex items-center bg-white/10 rounded-lg overflow-hidden border border-white/20">
            <button
              onClick={() => setLang('PT')}
              className={`px-3 py-1.5 text-xs font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                lang === 'PT' ? 'bg-[#F97316] text-white' : 'text-white/70 hover:text-white'
              }`}
            >
              PT
            </button>
            <button
              onClick={() => setLang('EN')}
              className={`px-3 py-1.5 text-xs font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                lang === 'EN' ? 'bg-[#F97316] text-white' : 'text-white/70 hover:text-white'
              }`}
            >
              EN
            </button>
          </div>

          {/* CTA Button */}
          <a
            href="mailto:geral@pamir.ao"
            className="flex items-center gap-2 bg-[#F97316] hover:bg-[#ea6c0a] text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            {ctaLabel}
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* Hamburger */}
        <button
          className="md:hidden text-white text-2xl cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0B1A35] border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => handleNav(item.href)}
              className="text-white/90 hover:text-[#F97316] text-sm font-medium text-left transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <div className="flex items-center gap-2">
            <span className="text-white/50 text-xs">{lang === 'PT' ? 'Idioma:' : 'Language:'}</span>
            <div className="flex items-center bg-white/10 rounded-lg overflow-hidden border border-white/20">
              <button
                onClick={() => setLang('PT')}
                className={`px-3 py-1.5 text-xs font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  lang === 'PT' ? 'bg-[#F97316] text-white' : 'text-white/70'
                }`}
              >
                PT
              </button>
              <button
                onClick={() => setLang('EN')}
                className={`px-3 py-1.5 text-xs font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  lang === 'EN' ? 'bg-[#F97316] text-white' : 'text-white/70'
                }`}
              >
                EN
              </button>
            </div>
          </div>
          <a
            href="mailto:geral@pamir.ao"
            className="bg-[#F97316] text-white text-sm font-semibold px-5 py-2.5 rounded-lg cursor-pointer whitespace-nowrap text-center"
          >
            {ctaLabel}
          </a>
        </div>
      )}
    </header>
  );
}
